/**
 * Public URLs for the two browse paths. The catalog keys them "A" and "B";
 * the URL says what they are. Old /path/A links still resolve and redirect.
 */
export type PathId = 'A' | 'B';

export const PATH_SLUGS: Record<PathId, string> = {
  A: 'pain-and-injury',
  B: 'improve-health',
};

export function pathUrl(id: PathId, categoryId?: string): string {
  return categoryId ? `/path/${PATH_SLUGS[id]}/${categoryId}` : `/path/${PATH_SLUGS[id]}`;
}

/** "pain-and-injury", "Pain-and-injury", "A" or "a" all resolve to "A". */
export function resolvePathId(param: string | null | undefined): PathId | undefined {
  const key = (param ?? '').trim().toLowerCase();
  if (!key) return undefined;
  if (key === 'a' || key === 'b') return key.toUpperCase() as PathId;
  return (Object.keys(PATH_SLUGS) as PathId[]).find((id) => PATH_SLUGS[id] === key);
}

/** True when the URL segment is already the canonical lowercase slug. */
export function isCanonicalPathSlug(param: string | undefined, id: PathId): boolean {
  return param === PATH_SLUGS[id];
}

/** Clinic list filtered to one service; `path` may be an id or a slug and is written as the slug. */
export function centresForServiceUrl(serviceSlug: string, path?: string | null): string {
  const id = resolvePathId(path);
  const query = `service=${encodeURIComponent(serviceSlug)}${id ? `&path=${PATH_SLUGS[id]}` : ''}`;
  return `/centres?${query}`;
}
